<div class="dashboard-metrics-download">
  <div class="dashboard-metrics-download__title">Module Answers</div>
  <div
    class="dashboard-metrics-download__cards"
    fxLayout="column"
    fxLayoutAlign="space-between stretch"
    fxLayoutGap="20px"
  >
    <div *ngFor="let intervention of interventions">
      <mat-card fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <p>{{ intervention.name }}</p>
          <dashboard-loader
            *ngIf="selectedIntervention?.id === intervention?.id && downloadingInterventionAnswers$ | async"
            [title]="'Downloading...'"
            [diameter]="50"
            [strokeWidth]="4"
          ></dashboard-loader>
          <button
            *ngIf="
              (selectedIntervention?.id === intervention?.id && interventionAnswersDownloaded$ | async) ||
              selectedIntervention?.id !== intervention?.id
            "
            [disabled]="intervention?.participantCount === null"
            mat-button
            color="primary"
            (click)="downloadInterventionAnswers(intervention)"
          >
            {{ 'Download' | uppercase }}
          </button>
        </div>
        <div
          *ngIf="getModulesWithSpecificItems(KEYS_FOR_DOWNLOAD_FILTER.AUDIO, intervention)?.length"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          fxFlexOffset="20px"
        >
          <mat-form-field appearance="fill" fxFlex="85">
            <mat-label>Select module to download audio files</mat-label>
            <mat-select
              (selectionChange)="setSelectedModuleSpecificModule(KEYS_FOR_DOWNLOAD_FILTER.AUDIO, $event?.source?.value)"
            >
              <mat-option [value]="null"></mat-option>
              <mat-option
                *ngFor="
                  let moduleWithSpecificItems of getModulesWithSpecificItems(
                    KEYS_FOR_DOWNLOAD_FILTER.AUDIO,
                    intervention
                  )
                "
                [value]="moduleWithSpecificItems"
              >
                {{ moduleWithSpecificItems.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button
            [disabled]="!selectedModuleWithAudio?.id"
            (click)="downloadInterventionFiles(KEYS_FOR_DOWNLOAD_FILTER.AUDIO, intervention)"
            mat-button
            color="primary"
          >
            {{ 'Download' | uppercase }}
          </button>
        </div>
        <div
          *ngIf="getModulesWithSpecificItems(KEYS_FOR_DOWNLOAD_FILTER.IMAGES, intervention)?.length"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          fxLayoutGap="20px"
        >
          <mat-form-field appearance="fill" fxFlex="85">
            <mat-label>Select module to download images</mat-label>
            <mat-select
              (selectionChange)="
                setSelectedModuleSpecificModule(KEYS_FOR_DOWNLOAD_FILTER.IMAGES, $event?.source?.value)
              "
            >
              <mat-option [value]="null"></mat-option>
              <mat-option
                *ngFor="
                  let moduleWithSpecificItems of getModulesWithSpecificItems(
                    KEYS_FOR_DOWNLOAD_FILTER.IMAGES,
                    intervention
                  )
                "
                [value]="moduleWithSpecificItems"
              >
                {{ moduleWithSpecificItems.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button
            [disabled]="!selectedModuleWithNetworkOrOrbits?.id"
            (click)="downloadInterventionFiles(KEYS_FOR_DOWNLOAD_FILTER.IMAGES, intervention)"
            mat-button
            color="primary"
          >
            {{ 'Download' | uppercase }}
          </button>
        </div>
      </mat-card>
    </div>
  </div>
  <div *ngIf="selectedStudy?.type == StudyType.TIIM">
    <div class="dashboard-metrics-download__report">Summary report</div>
    <div
      class="dashboard-metrics-download__cards"
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
      fxLayoutGap="20px"
    >
      <div *ngFor="let intervention of interventions">
        <mat-card fxLayout="column">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <p>{{ intervention.name }}</p>
            <button
              *ngIf="
                (selectedIntervention?.id === intervention?.id && interventionAnswersTimingDownloaded$ | async) ||
                selectedIntervention?.id !== intervention?.id
              "
              mat-button
              color="primary"
              (click)="downloadInterventionAnswersTiming(intervention)"
            >
              {{ 'Download' | uppercase }}
            </button>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
